import dayjs from 'dayjs'

export const formatearFecha = (valor, formato = 'DD/MM/YYYY') => {
  if (!valor) {
    return ''
  }
  const fecha = dayjs(valor)

  if (!fecha.isValid()) {
    return ''
  }

  return fecha.format(formato)
}

export const validarRangoFechas = (
  desdeValor,
  hastaValor,
  unidadComparacion = undefined
) => {
  if (!desdeValor || !hastaValor) {
    return false
  }

  const fechaDesde = dayjs(desdeValor)
  const fechaHasta = dayjs(hastaValor)

  if (!fechaDesde.isValid() || !fechaHasta.isValid()) {
    return false
  }

  return !fechaHasta.isBefore(fechaDesde, unidadComparacion)
}
